import ClassCard from "../components/ClassCard";
import "../styles/ClassroomPage.css";

export default function ClassroomPage({ classItems }) {
  const sorted = [...classItems].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div className="page">
      <div className="section">
        <div className="section-header">
          <div className="section-ornament">
            <div className="section-ornament-line" />
            <span className="section-label">Learning Sessions</span>
            <div className="section-ornament-line" />
          </div>
          <h2 className="section-title">
            The <em>Classroom</em>
          </h2>
          <div className="section-rule" />
          <p className="classroom-intro">
            A visual archive of our art education sessions — workshops,
            masterclasses, and hands-on learning moments, preserved in time.
          </p>
        </div>

        {sorted.length === 0 ? (
          <div className="classroom-empty">
            <div className="classroom-empty-icon">📚</div>
            <p>No sessions yet. Upload via the Admin panel.</p>
          </div>
        ) : (
          <div className="cards-grid">
            {sorted.map((item) => (
              <ClassCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
